import { useEffect, useRef, useState } from "react";
import { IconX } from "@tabler/icons-react";
import { lenis } from "../../utils/scroll";
import { BOOKING_EVENT, calendlyUrl } from "../../utils/booking";
import "./BookingDialog.css";

// Calendly inside a native modal <dialog>: Esc, focus trap and backdrop for
// free. The iframe only exists while open, so Calendly loads on demand and
// each open picks up the new service prefill.
export default function BookingDialog() {
  const ref = useRef(null);
  const [src, setSrc] = useState(null);

  useEffect(() => {
    const open = (e) => {
      setSrc(calendlyUrl(e.detail?.service));
      if (!ref.current.open) ref.current.showModal();
      lenis.stop();
    };
    window.addEventListener(BOOKING_EVENT, open);
    return () => window.removeEventListener(BOOKING_EVENT, open);
  }, []);

  const close = () => ref.current.close();

  return (
    <dialog
      ref={ref}
      className="booking"
      aria-label="Book a call"
      data-lenis-prevent
      onClose={() => {
        setSrc(null);
        lenis.start();
      }}
      // The iframe fills the dialog, so a click on the dialog itself is the backdrop
      onClick={(e) => e.target === ref.current && close()}
    >
      <button type="button" className="btn btn--icon booking-close" aria-label="Close booking" onClick={close}>
        <IconX size={20} stroke={1.5} />
      </button>
      {src && <iframe className="booking-frame" src={src} title="Book a call with Mohamed" />}
    </dialog>
  );
}
